import { RefObject, useEffect, useLayoutEffect, useRef } from 'react'

const useLockBodyScroll = (when: boolean): RefObject<HTMLDivElement | null> => {
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const currentRef = ref.current
    if (currentRef) {
      currentRef.addEventListener('touchmove', (e) => e.preventDefault())
    }
    return () => {
      if (currentRef) {
        currentRef.removeEventListener('touchmove', (e) => e.preventDefault())
      }
    }
  }, [])

  useLayoutEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow
    const htmlElement = document.documentElement

    if (when) {
      htmlElement.style.overflow = 'hidden'
      document.body.style.overflow = 'hidden'
    }
    return () => {
      htmlElement.style.overflow = 'unset'
      document.body.style.overflow = originalStyle
    }
  }, [when])

  return ref
}

export default useLockBodyScroll
